import { endpoints } from "@/configs/Settings";
import { HTTPResponseStatus } from "@/utils/enum";
import { useAuth } from "@/utils/useAuth";
import { useAxios } from "@/utils/useAxios";

/** PATCH /active no HCS. Usar só em HCS marcado como teleconsultoria. */
export async function patchHealthcareServiceActive(
  healthcareService: fhir5.HealthcareService,
  active: boolean,
) {
  if (!healthcareService.id) throw new Error("HealthcareService sem id");
  const url = `${endpoints.WORKFLOWFHIR}/HealthcareService/${healthcareService.id}`;
  const headers = {
    Accept: "application/fhir+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/json-patch+json",
  };
  const response = await useAxios.patch(
    url,
    [
      {
        op: healthcareService.active === undefined ? "add" : "replace",
        path: "/active",
        value: active,
      },
    ],
    { headers, timeout: 20000 },
  );
  if (response.status !== HTTPResponseStatus.Success) {
    throw new Error(`patch HealthcareService: ${response.status}`);
  }
}
